import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=7c3ac2e6"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=7c3ac2e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports